import Vue from 'vue'
import App from './App.vue'
import VTooltip from 'v-tooltip';
import axios from 'axios';
import ApiService from './common/api.service.js';
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

Vue.config.productionTip = false;
ApiService.init();

Vue.use(VTooltip);
Vue.use(Autocomplete);


new Vue({
  render: h => h(App),
  data () {
    return {
        isLogged: false,
        loading: false,
        myUser: {},
        token: '',
        boardId: 0,
        boardTitle: '',
        navigation: { navType: '', itemId: '' }
    }
  },
  methods: {
      isNavigating(name){
          return name == this.navigation.navType;
      },
      setNavigating(type, itemId){
          this.navigation.navType = type;
          this.navigation.itemId = itemId;
      },
      changeToBoard: function(name, boardId){
          this.boardId = boardId;
          this.boardTitle = name;
      },
      hasPerm(perm){
          return this.myUser.perms.find(x => x == perm) != null;
      },
      hasPermForAdmin(perm){
          return this.hasPerm('admin.'+perm) || this.hasPerm('admin.all');
      },
      hasPermForBoard(perm, boardId){
          return this.hasPerm('tasks.'+boardId+'.'+perm) || this.hasPerm('tasks.'+boardId+'.all');
      },
      login: function(response){
          this.myUser = response.user;
          this.token = this.myUser.token;
          this.isLogged = true;
          ApiService.setHeaders(this.token);
      },
      retrieveUser: function(){
          this.loading = true;
          axios
              .get(ApiService.getAction('user', 'getPersonalData'))
              .then(response => {
                  this.myUser = response.data.user;
                  this.myUser.perms = response.data.perms;
              })
              .catch(error => {
                  console.log(error);
              })
              .finally(() => this.loading = false);
      }
  }
}).$mount('#app');
